
export enum ModelTypeEnum {
    //starting Enums at 1 to avoid issues with javascript compare and 0 == undefined
    RequisitionModel = 1,
    ClientModel = 2,
    ContactModel = 3,
    UserModel = 4,
}
